<template>
  <div class="homepage">
    <nav class="navbar">
      <div class="container">
        <div class="brand">广东广福宏宇保险经纪有限公司</div>

        <div class="header-content">
          <div class="user-info">
            <span class="username">{{ username }}</span>
            <el-button type="text" class="logout-btn" @click="handleLogout">退出</el-button>
          </div>
        </div>
      </div>
    </nav>

    <!-- 侧边栏和主内容区域容器 -->
    <el-container>
      <!-- 侧边栏 -->
      <el-aside width="200px" style="background-color: #545c64">
        <el-menu
          :default-active="defaultActiveMenu"
          class="el-menu-vertical-demo"
          background-color="#545c64"
          text-color="#bfcbd9"
          active-text-color="#ffd04b"
          @select="handleSelect"
        >
          <el-menu-item index="andeCreateInsEIC">供方人员意外险投保</el-menu-item>
          <el-menu-item index="andeCreateInsEICSuppSum">意外险补充保额投保</el-menu-item>
          <el-menu-item index="anDeEICOrderList">订单管理</el-menu-item>
          <el-menu-item index="policyList">保单管理</el-menu-item>
          <el-menu-item index="employeeList">雇员管理</el-menu-item>
          <el-menu-item index="policyCorrectionList">批单管理</el-menu-item>
        </el-menu>
      </el-aside>

      <!-- 主内容区域 -->
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>

</template>

<script>
import {USER_NAME} from '@/store/mutation-types'
import Vue from 'vue'
import {getToken, removeToken} from '../utils/auth'
import {service} from '../utils/axios'

export default {
  name: 'sidebarMenu',
  components: {},
  data () {
    return {
      username: '', // 用户名
      defaultActiveMenu: 'anDeEICOrderList' // 默认激活的菜单项
    }
  },
  created () {
    // 根据当前路由设置默认激活的菜单项
    this.setDefaultActiveMenu()
    this.getUserPermissionByToken()
  },
  methods: { // 设置默认激活的菜单项
    setDefaultActiveMenu () {
      // 获取当前路由路径的最后一部分作为菜单项的索引
      const pathParts = this.$route.path.split('/')
      const currentPath = pathParts[pathParts.length - 1]
      // 检查当前路径是否在菜单项列表中
      const menuItems = ['andeCreateInsEIC', 'andeCreateInsEICSuppSum', 'anDeEICOrderList', 'policyList', 'employeeList', 'policyCorrectionList', 'resultEIC']
      if (menuItems.includes(currentPath)) {
        this.defaultActiveMenu = currentPath
      }
    },
    handleSelect (key, keyPath) {
      console.log('选中的菜单项索引:', key, '路径:', keyPath)
      const targetRoute = '/SidebarMenu/' + key
      // 检查当前路由是否已经是目标路由，避免重复导航错误
      if (this.$route.path !== targetRoute) {
        this.$router.push(targetRoute)
      }
    },
    async getUserPermissionByToken () {
      try {
        const res = await service.get('sys/permission/getUserPermissionByToken', {
          headers: {'x-access-token': getToken() || ''},
          timeout: 100000
        })
        if (res.success) {
          console.log('token未失效')
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.$message.error('登录过期，请重新登录')
          this.$router.push({path: '/login'})
        }
      }
    },
    // 退出登录方法
    handleLogout () {
      // 显示确认退出提示框
      this.$confirm('您确定要退出登录吗？', '确认退出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 用户点击确定，执行退出逻辑
        Vue.ls.remove(USER_NAME)
        removeToken()
        this.$router.push('/login')
        this.$message.success('退出登录成功！')
      }).catch(() => {
        // 用户点击取消，不执行操作
        this.$message.info('已取消退出')
      })
    }
  },
  watch: {
    '$route' () {
      this.setDefaultActiveMenu()
    }
  }
}
</script>

<style scoped>
/* 头部样式 */
.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.system-title {
  font-size: 18px;
  font-weight: bold;
}

/* 用户信息区域样式 */
.user-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.logout-btn {
  color: #ffd04b !important;
}

.username {
  font-size: 14px;
}

/* 侧边栏和主内容样式 */
el-aside {
  color: #333;
}

el-main {
  background-color: #f0f2f5;
  color: #333;
  padding: 20px;
}

/* 导航栏 */
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 15px 0;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.brand {
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .desktop-menu {
    display: none;
  }

  .hero {
    height: 60vh;
    margin-top: 60px;
  }

  .section {
    padding: 50px 0;
  }
}

/* 新增样式 */
/* 导航栏选中状态 */
.desktop-menu .active a,
.mobile-menu .active a {
  color: #3498db;
  font-weight: bold;
  position: relative;
}

.desktop-menu .active a::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #3498db;
}

/* 新增/修改样式 */
.homepage {
  display: flex; /* 启用Flex布局 */
  flex-direction: column; /* 垂直排列子元素 */
  min-height: 100vh; /* 至少占满整个视口高度 */
}

/* 搜索按钮样式 */
.search-btn {
  margin-left: 15px;
  padding: 12px 24px;
  font-size: 14px;
  border-radius: 4px;
}

/* 新增/修改样式 */
.homepage {
  display: flex; /* 启用Flex布局 */
  flex-direction: column; /* 垂直排列子元素 */
  min-height: 100vh; /* 至少占满整个视口高度 */
}

.product-main {
  flex: 1; /* 内容区域自动扩展占据剩余空间 */
}

/* 页脚 */
.footer {
  background: #2c3e50;
  color: #fff;
  padding: 40px 0;
  text-align: center;
  margin-top: auto; /* 页脚自动靠底部 */
}

.footer-links {
  margin-top: 20px;
  display: flex;
  gap: 20px;
  justify-content: center;
}

.footer-links a {
  color: #fff;
  text-decoration: none;
}

/* 返回顶部按钮 */
.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background: #3498db;
  color: #fff;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.3s;
}

.back-to-top:hover {
  opacity: 1;
}

/* 基础样式 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Microsoft YaHei', sans-serif;
  line-height: 1.6;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .search-btn {
    width: 100%;
    margin-left: 0;
    margin-top: 10px;
  }

  .desktop-menu {
    display: none;
  }

  .hero {
    height: 60vh;
    margin-top: 60px;
  }

  .section {
    padding: 50px 0;
  }
}

/* 新增样式 */
/* 导航栏选中状态 */
.desktop-menu .active a,
.mobile-menu .active a {
  color: #3498db;
  font-weight: bold;
  position: relative;
}

.desktop-menu .active a::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #3498db;
}

/* 导航栏 */
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 15px 0;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.brand {
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
}

.desktop-menu {
  display: flex;
  gap: 30px;
}

.desktop-menu li a, .mobile-menu li a {
  color: #333;
  text-decoration: none;
  transition: color 0.3s;
}

.desktop-menu li a:hover {
  color: #3498db;
}

.mobile-menu-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.mobile-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #fff;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/** 表格*/
.operation-menu {
  text-align: center;
  min-width: 100px;
}

.el-dropdown-menu__item {
  padding: 5px 20px;
}

.el-link {
  font-size: 13px;
}

</style>



// WEBPACK FOOTER //
// src/views/SidebarMenu.vue